module.exports = __webpack_public_path__ + "img/MTH.c55c4bc0.svg";